/* eslint-disable react/prop-types */
import DefaultMerchandise from '@assets/default-merchandise.svg';
import classes from './index.module.css';

/** 商品组件 */
export const Merchandise = ({
  item, className = '', children,
}) => {
  const {
    actualPrice,
    price,
    hasDiscount,
    image,
    imageUrl = DefaultMerchandise,
    itemTitle: title,
    sku,
    variantTitle,
  } = item || {};

  return (
    <section className={`${classes.merchandise} ${className}`}>
      <section className={classes.content}>
        <section className={classes.item_info}>
          <img src={image || imageUrl || DefaultMerchandise} className={classes.item_img} alt="" />
          <section className={classes.info_block}>
            {title ? <section className={classes.title}>{title}</section> : null}
            {variantTitle ? <section className={classes.sub_title}>{variantTitle}</section> : null}
            {sku ? <section className={classes.sub_title}>{`SKU: ${sku}`}</section> : null}
          </section>
        </section>
        <section className={classes.price_block}>
          {price ? <section className={classes.price}>{`${actualPrice}`}</section> : null}
          {hasDiscount ? <section className={classes.actual_price}>{`${price}`}</section> : null}
        </section>
      </section>
      {children}
    </section>
  );
};
